export class Step4 {
	public intitule = 'stepper.form.simp_in.step4';

	public getspan24 = 'form.simp_in.getspan24';
	public getspan25 = 'form.simp_in.getspan25';

	public numLot = 'form.simp_in.getnumlot';
	public description = 'form.simp_in.getspan27'; //888
	public valeur = 'form.simp_in.getvaleur';
	public devise = 'form.simp_in.getdevise';

	public lieuExecutionLivraison = 'form.simp_in.getspan25';///891

	constructor() {}
}
